export function appendArrayToFormData(formData, arrayName, array, options = {}) {
    const { fileFields = [], excludeFields = [] } = options;

    const keysToRemove = [];
    for (let [key] of formData.entries()) {
        // Match patterns like "pods[0].field_name" or "arrayName[index].field"
        if (key.startsWith(`${arrayName}[`) && key.includes('].')) {
            keysToRemove.push(key);
        }
    }

    // Remove the old dot notation fields
    keysToRemove.forEach(key => {
        formData.delete(key);
    });

    array.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
            // Skip excluded fields
            if (excludeFields.includes(key)) {
                return;
            }

            const value = item[key];
            const fieldName = `${arrayName}[${index}][${key}]`;

            // Skip null or undefined values
            if (value === null || value === undefined) {
                return;
            }

            // Handle File objects
            if (fileFields.includes(key) && value instanceof File) {
                formData.append(fieldName, value);
            }
            // Handle arrays (nested arrays)
            else if (Array.isArray(value)) {
                value.forEach((subItem, subIndex) => {
                    if (typeof subItem === 'object' && subItem !== null) {
                        // Nested object in array
                        Object.keys(subItem).forEach((subKey) => {
                            formData.append(
                                `${arrayName}[${index}][${key}][${subIndex}][${subKey}]`,
                                subItem[subKey] ?? ''
                            );
                        });
                    }
                    else {
                        // Primitive value in array
                        formData.append(
                            `${arrayName}[${index}][${key}][${subIndex}]`,
                            subItem ?? ''
                        );
                    }
                });
            }
            // Handle nested objects
            else if (typeof value === 'object' && !(value instanceof File)) {
                Object.keys(value).forEach((nestedKey) => {
                    formData.append(
                        `${arrayName}[${index}][${key}][${nestedKey}]`,
                        value[nestedKey] ?? ''
                    );
                });
            }
            // Handle primitive values (string, number, boolean)
            else {
                formData.append(fieldName, value);
            }
        });
    });
}
